import { Component } from '@angular/core';
import { NavController, NavParams, ToastController, LoadingController, ModalController } from 'ionic-angular';

import { Reviews, Dokumen } from '@providers/asset/';
import { FormReviewPage, DetailImagePage } from '../'

@Component({
  selector: 'page-asset-reviews',
  templateUrl: 'page.html'
})
export class AssetReviewsPage {

  reviews : any=[] ;
  asset_id='';
  asset_name='';
  asset_location_id='';
  asset_location_name='';
  loading:any;
  img_url='';
  
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private toastCtrl: ToastController,
    public loadingCtrl: LoadingController,
    public modalCtrl: ModalController,
    public reviewApi: Reviews,
    public dokumenApi: Dokumen
  ) {
    this.asset_id = this.navParams.get('asset_id');
    this.asset_name = this.navParams.get('asset_name');
    this.asset_location_id = this.navParams.get('location_id');
    this.asset_location_name = this.navParams.get('location_name');
    this.img_url = this.dokumenApi.file_url;

  }

  showLoading(){
    this.loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    this.loading.present();
  }

  presentToast(msg){
    this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'top'
    }).present();
  }

  ionViewWillEnter(){
    this.getList();
  }

  doRefresh(refresher) {
    refresher.complete();
    this.getList();
  }

  getList(){
    this.showLoading();
    let params = {
      asset_id : this.asset_id
    }
    this.reviewApi.get(params).subscribe((resp:any) => {
      this.reviews = resp.data;
      if(resp.data==''){
        this.presentToast('Belum ada review terkait asset ini');
      }
      this.loading.dismiss();
    });
  }
  
  add() {
    this.navCtrl.push(FormReviewPage, {
      asset_id      :this.asset_id,
      asset_name    :this.asset_name,
      location_id   :this.asset_location_id,
      location_name :this.asset_location_name
    });
  }

  detailImage(generated_name){
    let detailModal = this.modalCtrl.create(DetailImagePage, {
      url_image : this.img_url+generated_name
    });
    detailModal.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/asset/asset_reviews/page.ts